import {types, FETCH_UPDATE__ACTION} from './ActionActions';

const defaultState = {pending: true};

export default function (state = defaultState, action) {
  switch(action.type) {
    case types.FETCH:
    case types.FETCH_PENDING:
    case types.FETCH_SUCCESS:
    case FETCH_UPDATE__ACTION:
      state = Object.assign({}, state, {...action.payload});
      break;
  }
  return state;
}
